import React, {useState, useEffect} from 'react';
import Typist from 'react-typist-component';
import {Box, Typography, Container, Fade} from '@mui/material';

import cityMorning from "../../images/background/city/morning.png";
import cityDay from "../../images/background/city/day.png";
import cityEvening from "../../images/background/city/evening.png";

import developerMorning from "../../images/background/developer/morning.png"
import developerDay from "../../images/background/developer/day.png"
import developerEvening from "../../images/background/developer/evening.png"

import riverMorning from "../../images/background/river/morning.png"
import riverDay from "../../images/background/river/day.png"
import riverEvening from "../../images/background/river/evening.png"

const morningImages = [cityMorning, developerMorning, riverMorning];
const dayImages = [cityDay, developerDay, riverDay];
const eveningImages = [cityEvening, developerEvening, riverEvening];

const Home = () => {
    const [backgroundImage, setBackgroundImage] = useState("");
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        const hour = new Date().getHours();
        const randomImageIndex = Math.floor(Math.random() * 3);

        let selectedImage;
        if (hour >= 6 && hour < 18) {
            selectedImage = morningImages[randomImageIndex];
        } else if (hour >= 18 && hour < 21) {
            selectedImage = dayImages[randomImageIndex];
        } else {
            selectedImage = eveningImages[randomImageIndex];
        }

        setBackgroundImage(selectedImage);

        // Preload image for smooth display
        const img = new Image();
        img.src = selectedImage;
        img.onload = () => setLoaded(true);
    }, []);

    return (
        <Box
            sx={{
                position: 'relative',
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "calc(100vh - 64px)",
                width: "100%",
                overflow: "hidden",
            }}
        >
            {/* Background Image */}
            <Fade in={loaded} timeout={1000}>
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundImage: `url(${backgroundImage})`,
                        backgroundSize: "cover",
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat',
                        '&::after': {
                            content: '""',
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            background: 'linear-gradient(135deg, rgba(37, 99, 235, 0.3) 0%, rgba(30, 64, 175, 0.4) 100%)',
                        }
                    }}
                />
            </Fade>

            {/* Content */}
            <Container
                maxWidth="lg"
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    textAlign: 'center',
                    px: { xs: 2, sm: 3 }
                }}
            >
                <Fade in={loaded} timeout={1500}>
                    <Box>
                        <Typography
                            variant="h1"
                            component="h1"
                            sx={{
                                color: 'white',
                                fontWeight: 800,
                                textShadow: '0 4px 6px rgba(0, 0, 0, 0.3), 0 2px 4px rgba(0, 0, 0, 0.2)',
                                mb: 2,
                                letterSpacing: '-0.02em',
                                fontSize: {
                                    xs: '2rem',
                                    sm: '3rem',
                                    md: '4rem',
                                    lg: '4.5rem'
                                },
                                lineHeight: 1.1,
                            }}
                        >
                            <Typist cursor="|" loop={true}>
                                I'm Paul-Louis, a fullStack developer
                                <Typist.Delay ms={5_000}/>
                                <Typist.Backspace count={19}/>
                                mobile app developer
                                <Typist.Delay ms={5_000}/>
                                <Typist.Backspace count={38}/>
                            </Typist>
                        </Typography>

                        <Typography
                            variant="h5"
                            sx={{
                                color: 'rgba(255, 255, 255, 0.95)',
                                fontWeight: 400,
                                textShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                                maxWidth: 600,
                                mx: 'auto',
                                mt: 3,
                                fontSize: {
                                    xs: '1.1rem',
                                    sm: '1.25rem',
                                    md: '1.5rem'
                                }
                            }}
                        >
                            Building beautiful digital experiences
                        </Typography>
                    </Box>
                </Fade>
            </Container>

            {/* Decorative gradient blob */}
            <Box
                sx={{
                    position: 'absolute',
                    bottom: -100,
                    right: -100,
                    width: 400,
                    height: 400,
                    borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(37, 99, 235, 0.15) 0%, transparent 70%)',
                    filter: 'blur(40px)',
                    pointerEvents: 'none',
                }}
            />
        </Box>
    );
}

export default Home;
